import React from 'react';

function CaseTableLoading() {
  return (
    <div className="border  border-gray-100 bg-white shadow rounded-md p-4 w-full mx-auto animate-pulse">
      {/* Header */}
      <div className="grid grid-cols-2 gap-2 lg:grid-cols-4 lg:gap-4 mb-4">
        <div className="h-4 mb-4 bg-slate-300 rounded col-span-1"></div>
        <div className="h-4 mb-4 bg-slate-300 rounded col-span-1"></div>
        <div className="h-4 mb-4 bg-slate-300 rounded col-span-1 hidden lg:block"></div>
        <div className="h-4 mb-4 bg-slate-300 rounded col-span-1 hidden lg:block"></div>
      </div>

      {/* Rows */}
      {[1, 2, 3].map((item) => (
        <div key={item} className="grid lg:grid-cols-4 lg:gap-4 grid-cols-2 gap-2 mb-4">
          {/* Type Of Case */}
          <div className="h-4 mb-4 bg-slate-300 rounded col-span-1"></div>

          {/* Posted */}
          <div className="h-4 mb-4 bg-slate-300 rounded col-span-1"></div>

          {/* Adverse Party */}
          <div className="h-4 mb-4 bg-slate-300 rounded col-span-1 hidden lg:block"></div>

          {/* Case Progress: show small dots and lines */}
          <div className="flex items-center space-x-1 col-span-1 hidden lg:flex">
            {[1, 2, 3, 4, 5, 6].map((step) => (
              <React.Fragment key={step}>
                <div className="h-2 w-2 bg-slate-300 rounded-full"></div>
                {step !== 6 && <div className="flex-1 h-0.5 bg-slate-300"></div>}
              </React.Fragment>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}


export default CaseTableLoading
